import Flatpickr from 'flatpickr';
import { Russian as ru } from 'flatpickr/dist/l10n/ru';

import Module from '@/scripts/old/classes/Module';
import { parseAttr } from '@/scripts/old/helpers/utils';

const NAMESPACE = 'data-date-input';

class DateInputsModule extends Module {
  constructor() {
    super(`[${NAMESPACE}]`);
  }

  initInstance(el) {
    const config = parseAttr(el, NAMESPACE);

    const fp = new Flatpickr(el, ({
 wrap: false,
      dateFormat: 'd.m.Y',
      enableTime: false,
      locale: ru,
      allowInput: true,
...config,
}));
    this.instances.set(el, fp);
  }

  destroyInstance(instance) {
    instance.destroy();
  }
}

export default new DateInputsModule();
